export const CASHIER_SESSION_TYPES = {
    DEPOSIT: 1,
    WITHDRAWAL: 4,
    FULL_CASHIER_CDH: 9,
    FULL_CASHIER: 8,
    QUICK_DEPOSIT: 16,
    COOLING_OFF: 18,
    VERIFY_ID: 20,
    MOBILE_VERIFY_ID: 21
};
